(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.LinkedInPrivatePost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'LinkedIn private post data',
            channelName: sourceDetails[sources.LINKEDIN].name,
            postName: sourceDetails[sources.LINKEDIN].postName,

            storageDimensions: [
                'post_id'
            ],

            availableDimensions: [
                'companyId',
                'companySetId',
                'day',
                'dayOfWeek', 'hourOfDay',
                'postTagId',
                'hashtag',
                'keyword'
            ],

            fields: {
                caption: {
                    dataType: dataType.STRING
                },
                captured_at: {
                    dataType: dataType.DATE
                },
                clicks: {
                    dataType: dataType.INTEGER
                },
                comments: {
                    dataType: dataType.INTEGER
                },
                company_id: {
                    dataType: dataType.STRING
                },
                company_name: {
                    dataType: dataType.STRING
                },
                engagement_rate_by_presence_reach: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                engagement_total: {
                    dataType: dataType.INTEGER
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                presence_reach: {
                    dataType: dataType.INTEGER
                },
                image: {
                    dataType: dataType.STRING
                },
                impressions: {
                    dataType: dataType.INTEGER
                },
                likes: {
                    dataType: dataType.INTEGER
                },
                linked_in_company_name: {
                    dataType: dataType.STRING
                },
                minutes_watched: {
                    dataType: dataType.NUMERIC
                },
                native_id: {
                    dataType: dataType.STRING
                },
                post_id: {
                    dataType: dataType.STRING
                },
                post_link: {
                    dataType: dataType.STRING
                },
                post_tag_ids: {
                },
                post_type: {
                    dataType: dataType.STRING
                },
                published_at: {
                    dataType: dataType.DATE
                },
                shares: {
                    dataType: dataType.INTEGER
                },
                social_engagement_rate_by_presence_reach: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_rate_by_impression: {
                    dataType: dataType.NUMERIC
                },
                social_engagement_total: {
                    dataType: dataType.INTEGER
                },
                source: {
                    dataType: dataType.INTEGER
                },
                video_viewers: {
                    dataType: dataType.INTEGER
                },
                video_views: {
                    dataType: dataType.INTEGER
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost, // TODO: rename publicPost into just post
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
